import React from "react";
import { AlertTriangleIcon } from "./PrivacyIcons";

const PrivacySecurityAlerts = ({ loginAlerts, setLoginAlerts }) => {
  return (
    <div className="v2-privacy-pg-card">
      <div className="v2-privacy-pg-card__header">
        <div className="v2-privacy-pg-card__icon-wrap" style={{ background: "#fef2f2" }}>
          <AlertTriangleIcon size={20} color="#eb1414" />
        </div>
        <div>
          <h3 className="v2-privacy-pg-card__title">Security Alerts</h3>
          <p className="v2-privacy-pg-card__subtitle">
            Get notified about security events
          </p>
        </div>
      </div>
      <div className="v2-privacy-pg-card__body">
        <div className="v2-privacy-pg-alert-row">
          <div className="v2-privacy-pg-alert-row__text">
            <span className="v2-privacy-pg-alert-row__label">Login Alerts</span>
            <span className="v2-privacy-pg-alert-row__desc">
              Receive alerts when someone logs into your account from a new device
            </span>
          </div>
          <button
            className={`v2-privacy-pg-toggle${loginAlerts ? " v2-privacy-pg-toggle--on" : ""}`}
            onClick={() => setLoginAlerts(!loginAlerts)}
          >
            <span className="v2-privacy-pg-toggle__knob" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacySecurityAlerts;
